module.exports = __webpack_public_path__ + "img/icon_answer_upload_default.4eba12a5.svg";